var map = {
	"./at.jpg": 55390,
	"./atortho.jpg": 27122,
	"./esri.jpg": 32718,
	"./fauna.jpg": 16045,
	"./icgc.jpg": 5986,
	"./icgcortho.jpg": 11084,
	"./ign.jpg": 77435,
	"./ignes.jpg": 83243,
	"./ignesortho.jpg": 53463,
	"./ignortho.jpg": 40541,
	"./ignslopes.jpg": 33791,
	"./opentopomap.jpg": 54134,
	"./swisstopo.jpg": 71768,
	"./swisstopoortho.jpg": 86658,
	"./swisstoposlopes.jpg": 98606,
	"./uk.jpg": 22656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4891;